import { defineStore } from 'pinia'
import { LocaleSettingsType } from '@/settings/locale'
import { getLocaleInfoCache } from '@/locales/helper'
import { storageProxy } from '@/utils/cache'
import { CacheKeys } from '@/enums/cacheEnum'
import { store } from '../index'
import { enableStoreHMRUpdate } from '../helper'

export type LocaleInfo = LocaleSettingsType

export interface State {
  localeInfo: LocaleInfo
}

const localeInfo = getLocaleInfoCache()

/**
 * 多语言store
 */
export const useLocaleStore = defineStore('localeStore', {
  state: (): State => ({
    localeInfo,
  }),
  getters: {
    getOriginalLocale: (state) => state.localeInfo.originalLocale,
    getLocale: (state) => state.localeInfo.locale,
    isChina: (state) => ['zh_CN', 'zh_TW'].includes(state.localeInfo.locale),
  },
  actions: {
    setLocaleInfo(localeInfo: Partial<LocaleInfo>) {
      console.log(localeInfo)
      this.localeInfo = { ...this.localeInfo, ...localeInfo }
      storageProxy.set(CacheKeys.LOCALE, localeInfo)
    },
  },
})

enableStoreHMRUpdate(useLocaleStore)

export function useLocaleStoreWithOut() {
  return useLocaleStore(store)
}
